import dashboard from './dashboard';
import catalog from './catalog';
import admin from './admin';
import exporting from './export';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, admin, exporting, catalog]
};
export default menuItems;
